import { useState, useCallback } from 'react';

interface UsePaginationOptions {
  initialPage?: number;
}

interface UsePaginationReturn {
  page: number;
  setPage: (page: number) => void;
  hasNextPage: boolean;
  setHasNextPage: (hasNext: boolean) => void;
  fetchNextPage: () => void;
  resetPage: () => void;
}

const usePagination = ({ initialPage = 1 }: UsePaginationOptions = {}): UsePaginationReturn => {
  const [page, setPage] = useState(initialPage);
  const [hasNextPage, setHasNextPage] = useState(false);

  const fetchNextPage = useCallback(() => {
    if (hasNextPage) {
      setPage((prev) => prev + 1);
    }
  }, [hasNextPage]);

  const resetPage = useCallback(() => {
    setPage(initialPage);
    setHasNextPage(false);
  }, [initialPage]);

  return {
    page,
    setPage,
    hasNextPage,
    setHasNextPage,
    fetchNextPage,
    resetPage,
  };
};

export default usePagination;
